import {Component, forwardRef, Input, Provider} from '@angular/core'
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms'

export function simpleValueAccessorProvider(componentType: any): Provider {
  return {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => componentType),
    multi: true,
  }
}

@Component({
  template: '',
})
export abstract class SimpleValueAccessorSupportComponent<T> implements ControlValueAccessor {

  @Input()
  value!: T

  onChange = (_: T) => {}

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
  }

  writeValue(value: T): void {
    if (typeof value === 'object') {
      this.value = {...value}
    } else {
      this.value = value
    }
  }

  valueChanged(): void {
    this.onChange(this.value)
  }
}
